import { App } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useCallback } from 'react';

import { useQuoteStyles } from '../../styles/quote.styles';
import { useQuoteRestrictionsMessageStyles } from './QuoteRestrictionsMessage.styles';

export function useQuoteMessage() {
  const { message } = App.useApp();
  const { styles } = useQuoteRestrictionsMessageStyles();

  const showQuoteMessage = useCallback(
    (formatMessage, onClose) => {
      const key = Math.random();

      message.warning({
        content: (
          <div className={styles.quotesNotificationContent}>
            <span>
              {formatMessage({ id: 'book.newQuote.country-restriction' })}
            </span>{' '}
            |{' '}
            <span>
              {formatMessage({ id: 'book.newQuote.weight-restriction' })}
            </span>
            <br />
            {formatMessage({ id: 'book.newQuote.warning-contact' })}
            <a
              href="https://quick.aero/contact-us/"
              target="_blank"
              rel="noreferrer"
            >
              <u>
                {formatMessage({
                  id: 'book.newQuote.warning-customer-service',
                })}
              </u>
            </a>
          </div>
        ),
        className: styles.quotesNotification,
        duration: 10,
        onClose,
        key,
      });
      return key;
    },
    [message, styles]
  );

  const showQuoteDisclaimer = useCallback(
    formatMessage => {
      const key = Math.random();

      message.warning({
        content: (
          <div className={styles.quotesNotificationContent}>
            <div className={styles.quoteDisclaimerNotification}>
              {formatMessage({ id: 'book.newQuote.flightsDisclaimer' })}
            </div>
          </div>
        ),
        className: styles.quotesNotification,
        duration: 10,
        key,
      });
      return key;
    },
    [message, styles]
  );

  return { showQuoteMessage, showQuoteDisclaimer };
}

export function useQuoteExpirationMessage() {
  const { message } = App.useApp();
  const { styles } = useQuoteRestrictionsMessageStyles();
  const { styles: sharedStyles } = useQuoteStyles();

  const showQuoteExpirationMessage = useCallback(
    (formatMessage, expiryDateTime, referenceNo) => {
      const key = Math.random();
      message.warning({
        content: (
          <div className={styles.quotesNotificationContent}>
            <p className={styles.newQuoteNotificationHeader}>
              {formatMessage({ id: 'book.quote.savedQuoteMessage' })}
            </p>
            <p>
              <div
                className={classNames(
                  sharedStyles.quoteIdLabel,
                  styles.quoteIdLabel
                )}
              >
                {formatMessage({ id: 'book.quote.quoteId' })}
                <span className={sharedStyles.quoteId}>
                  {referenceNo} |{' '}
                  {formatMessage(
                    {
                      id: 'book.quote.expireQuote',
                    },
                    {
                      expireDate: moment(expiryDateTime)
                        .format('DDMMMYYYY')
                        .toUpperCase(),
                    }
                  )}
                </span>
              </div>
            </p>
          </div>
        ),
        className: styles.quotesNotification,
        duration: 10,
        key,
      });
      return key;
    },
    [message, styles, sharedStyles]
  );

  return { showQuoteExpirationMessage };
}

export function useRetrieveQuoteMessage() {
  const { message } = App.useApp();
  const { styles } = useQuoteRestrictionsMessageStyles();

  const showRetrieveQuoteMessage = useCallback(
    (formatMessage, onClose) => {
      const key = Math.random();
      message.warning({
        content: (
          <div className={styles.quotesNotificationContent}>
            {formatMessage({ id: 'quote.retrieveQuote.title' })}
            <br />
            {formatMessage({
              id: 'quote.retrieveQuote.message',
            })}
          </div>
        ),
        className: styles.quotesNotification,
        duration: 10,
        onClose,
        key,
      });
      return key;
    },
    [message, styles]
  );

  return { showRetrieveQuoteMessage };
}
